import { css } from 'styled-system/css';

export const promotionButtonStyles = {
	button: css({
		base: {
			cursor: 'pointer',
			position: 'fixed',
			bottom: '0',
			left: '0',
			borderRadius: '0 24px 0 0',
			bgColor: '#F8B600',
			color: '#6A2700',
			p: '24px 6px 6px 6px',
			minW: '70px',
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'center'
		}
	}),
	icon: css({
		base: {
			position: 'absolute',
			top: '-10px',
		}
	}),
	img: css({
		base: {
		
		}
	}),
	text: css({
		base: {
			textAlign: 'center',
		}
	}),
}

